<template>
  <section class="site-pitch" ref="root">
    <div class="site-pitch__wrapper">
      <div class="site-pitch__wrapper__illustration">
        <Transition name="fade">
          <Animation v-if="mounted" />
        </Transition>
        
      </div>
      <div class="site-pitch__wrapper__text">
        <h2 class="site-pitch__wrapper__text__title site-section-title">
          Fini les CRA sur Excel et les scans de signature
        </h2>
        <div class="site-pitch__wrapper__text__description">
          Remplissez votre calendrier, signez, envoyez au client pour validation. Export PDF automatique. Gratuit et illimité.
        </div>
        <div class="site-pitch__wrapper__text__action">
          <SiteButton
            label="Créer mon CRA"
            has-arrow
            class="site-pitch__wrapper__text__action__button"
            full-width-mobile
            @click="goToCraApp"
          />
        </div>
        <div class="
          site-pitch__wrapper__text__description
          site-pitch__wrapper__text__description--cra-express"
        >
         Besoin de plus ? Tableau de bord, notifications, intégration Pennylane / Indy / Tiime.
        </div>
        <div class="site-pitch__wrapper__text__action">
          <SiteButton
            type="secondary"
            label="Découvrir l'offre Intégration"
            has-arrow
            class="site-pitch__wrapper__text__action__button"
            full-width-mobile
            @click="$router.push({ hash: '#price', path: '/' })"
          />
        </div>
      </div>
    </div>
    <GlobalEvents
      target="window"
      @scroll="appear"
    />
  </section>
</template>

<script setup>
  import SiteButton from '@/components/SiteButton'
  import { GlobalEvents } from 'vue-global-events'
  import debounce from 'lodash.debounce'

  const router = useRouter()

  const goToCraApp = () => {
    router.push({ name: 'app' })
  }

  const Animation = defineAsyncComponent(() => import('./Animation'))
  const emit = defineEmits(['signup'])

  const root = ref(null)

  const mounted = ref(false)

  const appear = debounce(() => {
    if (!mounted.value) {
      mounted.value = true
    }
  }, 200, {
    maxWait: 200
  })

  onMounted(() => {
    if (root.value.getBoundingClientRect().y - window.innerHeight < 0) {
      mounted.value = true
    }
  })

  setTimeout(() => {
    mounted.value = true
  }, 3000)
</script>

<style lang="scss">
  @use './index.scss';
</style>
